import {EditorDrawingData_v4, EditorDrawingData_v5} from "../../../models/editor";

export function from_v4_to_v5(schema: EditorDrawingData_v4): EditorDrawingData_v5 {
	return {
		...schema,
		schemaVersion: 5,
	};
}
